module.exports = __webpack_public_path__ + "media/images/accept_booking-35aa6af7dbcf0de1e2dc7b990456a3c3.gif";